(function($, root, undefined) {
	$(function() {
		"use strict";

		$("[data-fancybox]").fancybox({
			animationEffect: "fade"
		});

		$(".hamburger").click(function() {
			$(this).toggleClass("is-active");
			$(".primary-navigation")
				.stop()
				.toggleClass("active");
			$("body").toggleClass("disableScroll");
			$(".logo, footer, #content").toggleClass("blurContent");

			if ($(this).hasClass("is-active")) {
				$("#menu-main-menu a")
					.first()
					.focus();
			} else {
				$("#content").focus();
			}
		});

		$("#menu-main-menu a")
			.last()
			.keydown(function() {
				setTimeout(function() {
					$(".hamburger").focus();
				}, 0);
			});

		$(".owl-carousel").owlCarousel({
			loop: true,
			items: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			autoplayTimeout: 8000
		});

		$(".banner-carousel").owlCarousel({
			loop: true,
			items: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			autoplayTimeout: 8000,
			dotsData: false,
			animateOut: "fadeOut"
		});

		$(".j-lazy-image").each(function() {
			var imgSrcUrl = $(this).data("src");
			var imgSrcSetUrl = $(this).data("srcset");
			$(this).waypoint(
				function() {
					if ($(this.element).attr("data-srcset")) {
						$(this).load(imgSrcSetUrl, function() {
							$(this.element)
								.attr("srcset", imgSrcSetUrl)
								.addClass("loaded");
						});
					}
					if ($(this.element).data("src")) {
						$(this).load(imgSrcUrl, function() {
							$(this.element)
								.attr("src", imgSrcUrl)
								.addClass("loaded");
						});
					}
				},
				{ offset: "90%" }
			);
		});

		$(".j-lazy-bg").each(function() {
			var imgSrcUrl = $(this).data("src");
			var thumbImgSrcUrl = $(this).css("background-image");
			$(this).waypoint(
				function() {
					$(this).load(imgSrcUrl, function() {
						$(this.element)
							.css({
								"background-image":
									"url(" + imgSrcUrl + "), " + thumbImgSrcUrl
							})
							.addClass("loaded");
					});
				},
				{ offset: "90%" }
			);
		});
	});
	String.prototype.trunc =
		String.prototype.trunc ||
		function(n) {
			return this.length > n ? this.substr(0, n - 1) + "&hellip;" : this;
		};
	if (document.URL.indexOf("news") >= 0) {
		var configProfile = {
			profile: { screenName: "Butlersofkent" },
			// domId: "j-twitter-feed",
			maxTweets: -1,
			enableLinks: true,
			showUser: true,
			showTime: true,
			showImages: true,
			lang: "en",
			customCallback: populateTweets
		};
		twitterFetcher.fetch(configProfile);

		function populateTweets(tweets) {
			for (var i = 0, lgth = tweets.length; i < lgth; i++) {
				var tweet = $(tweets[i]);
				// console.log(tweet);

				// Get the tweet data
				var tweetData = {
					username: configProfile.profile.screenName,
					avatar:
						tweet[0].childNodes[1].childNodes[0].attributes[4]
							.nodeValue,
					text: tweet[1].innerHTML,
					link: tweet[2].childNodes[0].attributes.href.nodeValue,
					time: tweet[2].innerText,
					media: ""
				};
				if (tweet[4]) {
					tweetData["media"] = tweet[4].innerHTML;
				}
				// console.log(tweetData);

				// Build the tweet content
				var tweetHtml =
					'<div class="tweet">' +
					'<p class="tweet__meta">' +
					'<a href="https://twitter.com/' +
					tweetData.username +
					'" target="_blank" class="tweet__username"><i class="fab fa-twitter"></i> @' +
					tweetData.username +
					"</a>" +
					'<img class="tweet__avatar" src="' +
					tweetData.avatar +
					'" />' +
					"</p>" +
					'<p class="tweet__text">' +
					tweetData.text +
					'</p><div class="tweet__media">' +
					tweetData.media +
					'</div><a href="' +
					tweetData.link +
					'" target="_blank"class="tweet__time"><i class="fas fa-clock"></i> ' +
					tweetData.time +
					"</a>" +
					"</div>";
				// Add the tweet to the carousel
				$(".tweets").append(tweetHtml);
			}
		}
	}
})(jQuery, this);
